<script setup>
import { computed } from "vue";
import SettingsField from "./SettingsField.vue";
import { INDIAN_STATES } from "./companySettingsRules";
import { useCompanySettings } from "./useCompanySettings";

const { form } = useCompanySettings();
const stateOptions = INDIAN_STATES.map((state) => ({ value: state.name, label: `${state.name} (${state.code})` }));
const stateHint = computed(() => (form.StateCode ? `State code ${form.StateCode} is used for GST (intra/inter-state)` : ""));
</script>

<template>
  <div class="cs-panel">
    <section class="cs-group">
      <header class="cs-group-head">
        <h5>Business name</h5>
        <p>How your business appears on invoices and reports.</p>
      </header>
      <div class="row g-3">
        <div class="col-md-6">
          <SettingsField field="CompanyName" label="Legal / registered name" placeholder="e.g. Acme Traders Pvt Ltd" maxlength="150" />
        </div>
        <div class="col-md-6">
          <SettingsField
            field="DisplayName"
            label="Display name"
            placeholder="e.g. Acme Store"
            hint="Shorter name shown in the app header. Leave empty to use the legal name."
            maxlength="100"
          />
        </div>
      </div>
    </section>

    <section class="cs-group">
      <header class="cs-group-head">
        <h5>Address</h5>
        <p>Printed on every invoice. The state decides whether CGST+SGST or IGST applies.</p>
      </header>
      <div class="row g-3">
        <div class="col-md-6">
          <SettingsField field="AddressLine1" label="Building, street" placeholder="e.g. 12/345, MG Road" maxlength="200" />
        </div>
        <div class="col-md-6">
          <SettingsField field="AddressLine2" label="Area, landmark" placeholder="e.g. Near City Hospital" maxlength="200" />
        </div>
        <div class="col-md-4">
          <SettingsField field="City" placeholder="e.g. Kochi" maxlength="100" />
        </div>
        <div class="col-md-5">
          <SettingsField field="State" type="select" :options="stateOptions" placeholder="Select state" :hint="stateHint" />
        </div>
        <div class="col-md-3">
          <SettingsField field="PinCode" label="PIN code" placeholder="682016" maxlength="6" inputmode="numeric" />
        </div>
      </div>
    </section>

    <section class="cs-group">
      <header class="cs-group-head">
        <h5>Contact</h5>
        <p>Customers see these on invoices.</p>
      </header>
      <div class="row g-3">
        <div class="col-md-6">
          <SettingsField field="Phone1" type="tel" placeholder="+91 98765 43210" maxlength="20" inputmode="tel" />
        </div>
        <div class="col-md-6">
          <SettingsField field="Email" type="email" placeholder="accounts@example.com" maxlength="150" />
        </div>
      </div>
    </section>
  </div>
</template>
